/**
 * PezzoNonCaricato — la pagina d'errore della rotta del Referto (la
 * «seconda difesa», Alex 2/10 notte; il perche' per esteso sta in
 * utils/versioneInLinea.js, accanto a ricaricaPerPezzo).
 *
 * Il Referto e' l'unica rotta caricata a richiesta (React.lazy nella tabella
 * navigazione/schermate.js; l'errorElement lo mette App.js):
 * il suo codice e' un file a parte, e nei secondi dello scambio della build
 * puo' non arrivare (ChunkLoadError). Fino al 2/10 al suo posto c'era la
 * pagina d'errore del router. Adesso la pagina si ricarica da sola UNA
 * volta, con le guardie di sempre e solo se i file in linea rispondono (la
 * decisione aspetta quella verifica: intanto a schermo resta l'attesa); se
 * non basta, o se una guardia o il server la fermano, lo dice qui, con
 * «Ricarica».
 *
 * UN ERRORE CHE NON E' UN PEZZO MANCANTE NON SI TOCCA: si rilancia, e lo
 * prende la pagina d'errore del router come prima. Un difetto vero del
 * Referto deve restare visibile - lo cerca il caso 18 dello scenario 15 dei
 * percorsi (18g; verificaRotte il referto non lo apre) - e una ricarica non
 * lo correggerebbe: ne farebbe solo un giro.
 *
 * Il foglio di stile e' suo e sta nel bundle principale: quando il pezzo
 * del referto non arriva, non arriva nemmeno Referto.css.
 */
import React, { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import { allaQuiete } from '../services/api';
import { pezzoNonCaricato, ricaricaPerPezzo, ricaricaAMano } from '../utils/versioneInLinea';
import '../styles/PezzoNonCaricato.css';

/* I manuali lo citano alla lettera. «Ricarica» e' il nome del pulsante. */
export const MSG_REFERTO_NON_CARICATO =
    'Il referto non si è aperto: il gestionale non è riuscito a scaricarne la pagina. '
    + 'Succede nei pochi secondi in cui esce una versione nuova, o con la rete caduta: premi Ricarica per riprovare.';

export default function PezzoNonCaricato({ messaggio, attesa }) {
    const errore = useRouteError();
    const pezzo = pezzoNonCaricato(errore);
    /* false finche' si decide o la ricarica e' partita: a schermo resta
       l'attesa di prima («Apertura del referto…»), e chi aspettava il
       referto vede il referto, senza un messaggio d'errore di passaggio. */
    const [fermo, setFermo] = useState(false);

    useEffect(() => {
        if (!pezzo) return undefined;
        let smontato = false;
        const decidi = async () => {
            if (smontato) return;
            /* La decisione passa dalla rete (i file in linea ci sono?): chi
               nel frattempo e' andato altrove non deve trovarsi una ricarica
               sulla pagina nuova, ne' questo componente aggiornarsi smontato. */
            let no;
            /* Un imprevisto nella decisione non lascia l'attesa per sempre:
               il messaggio, con «Ricarica». */
            try { no = await ricaricaPerPezzo(() => !smontato); } catch (e) { no = 'imprevisto'; }
            if (no === null || smontato) return;            // la ricarica e' partita, o siamo altrove
            /* Una scrittura in volo (un campo della pagina di prima che si
               salvava uscendo): ricaricare la interromperebbe. Si aspetta che
               torni e si decide da capo, con tutte le guardie. */
            if (no === 'richiesta') { allaQuiete(decidi); return; }
            setFermo(true);
        };
        decidi();
        return () => { smontato = true; };
    }, [pezzo]);

    if (!pezzo) throw errore;
    if (!fermo) return <p className="pnc-attesa">{attesa}</p>;
    return (
        <div className="pnc-pagina">
            <p className="rm-messaggio rm-messaggio-attenzione" role="alert">{messaggio}</p>
            <div className="pnc-azioni">
                <button type="button" className="rm-btn rm-btn-primario" onClick={ricaricaAMano}>Ricarica</button>
            </div>
        </div>
    );
}
